import { useEffect, useRef, useState } from "react";

export const useDropDown = (options = []) => {
  const [inputOptions, setInputOptions] = useState(options);
  const [inputValue, setInputValue] = useState("");
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const listRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    const inputData = inputValue.toLowerCase().trim();
    if (inputData) {
      const filteredOptions = options.filter(({ name }) =>
        name.toLowerCase().includes(inputData),
      );

      setInputOptions(filteredOptions);
    }

    setHighlightedIndex(-2);
  }, [inputValue, options]);

  useEffect(() => {
    if (highlightedIndex >= -1 && itemRefs.current[highlightedIndex]) {
      itemRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  const handleInputChange = e => {
    const { value } = e.target;
    setInputValue(value);
  };

  return {
    listRef,
    itemRefs,
    inputOptions,
    inputValue,
    setHighlightedIndex,
    highlightedIndex,
    handleInputChange,
  };
};
